/** Canonical safe outcomes for explicit mapping-check requests. */
export const PRODUCT_MAPPING_CHECK_OUTCOMES = {
  QUEUED: "QUEUED",
  EXISTING: "EXISTING",
  SKIPPED: "SKIPPED",
  FAILED: "FAILED",
  UNCONFIRMED: "UNCONFIRMED",
} as const;

export type ProductMappingCheckOutcome =
  (typeof PRODUCT_MAPPING_CHECK_OUTCOMES)[keyof typeof PRODUCT_MAPPING_CHECK_OUTCOMES];

/** Merchant-visible audit action for an accepted new explicit check job. */
export const PRODUCT_MAPPING_CHECK_AUDIT_ACTIONS = {
  QUEUED: "PRODUCT_MAPPING_CHECK_QUEUED",
  IDENTITY_REVIEW_REQUIRED: "PRODUCT_MAPPING_IDENTITY_REVIEW_REQUIRED",
} as const;

/** Safe worker outcome codes for a completed explicit mapping check. */
export const PRODUCT_MAPPING_CHECK_FAILURE_CODES = {
  IDENTITY_REVIEW_REQUIRED: "IDENTITY_REVIEW_REQUIRED",
  INCOMPLETE_CURRENT_EVIDENCE: "INCOMPLETE_CURRENT_EVIDENCE",
} as const;
